'use strict';

module.exports = /* @ngInject */ function () {
	var translations = null;
	var currentLocale = '';

	/**
	 * Parses the string from a poFile to JSON and stores it
	 * @param fileString
	 * @param locale
	 */
	this.changeLanguage = function (fileString, locale) {
		translations = fileString;
		currentLocale = locale;
	};

	this.$get = /* @ngInject */ function ($resource, $http, apiConfig) {
		return {
			/**
			 * translates a string if the translations are fully loaded and if the translation is available
			 * @param stringToBeTranslated
			 * @returns {*}
			 */
			translate: function (stringToBeTranslated) {
				return translations !== null && stringToBeTranslated in translations && translations[stringToBeTranslated] !== '' ?
					translations[stringToBeTranslated] : stringToBeTranslated;
			},

			/**
			 * checks if a translation file has been loaded
			 * @returns {boolean}
			 */
			isTranslationAvailable: function () {
				return translations !== null;
			},

			/**
			 * Returns the current locale
			 * @returns {string}
			 */
			getCurrentLocale: function(){
				return currentLocale;
			},

			/**
			 * requests a translation file, parses it to JSON and stores it
			 */
			getTranslations: function (language) {
				return new Promise(function (resolve){
					if(language !== currentLocale){
						var url = apiConfig.fileOrigin + '/locale/' + language + '.json';
						$http.get(url)
							.then(function(response) {
								translations = response.data;
								currentLocale = language;
								resolve(response.data);
							}).catch(function (error) {
							if(error.status === 404){
								translations = null;
							}
						})
					} else {
						resolve(translations);
					}
				});
			}
		}
	}
}
